import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MinutesToHoursPipe } from "./minutes-to-hours.pipe";
import { MinutesToHoursDecimalPipe } from "./minutes-to-hours-decimal.pipe";
import { BooleanValuePipe } from "./boolean-value.pipe";
import { MinutesToHoursDecimalCeilPipe } from "./minutes-to-hours-decimal-ceil.pipe";

@NgModule({
  declarations: [MinutesToHoursPipe, BooleanValuePipe, MinutesToHoursDecimalPipe, MinutesToHoursDecimalCeilPipe],
  imports: [CommonModule],
  exports: [MinutesToHoursPipe, BooleanValuePipe, MinutesToHoursDecimalPipe, MinutesToHoursDecimalCeilPipe],
})
export class CustomPipesModule { }
// TODO this should probably be in the pipes folder ;)
